import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BDrugTypeFetchListCard } from './BDrugTypeFetchListCard'
export const BDrugTypePopperListCard = defineComponent({
  name: 'BDrugTypePopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids }} tippyConfig={getAsyncListTippyConfig()} component={BDrugTypeFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
